import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { useTranslation } from 'react-i18next';

const RoleForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpForm.Input
                label={t('role.form.name')}
                name='name'
                rules={[{ required: true, message: t('role.form.nameRequired') }]}
            />
            <OpForm.Input label={t('role.form.description')} name='description' />
        </>
    );
};

export default RoleForm;